import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CurrentUserService } from '../services/current-user.service';

@Injectable()
export class AuthGuard  {

    constructor(private router: Router, private me: CurrentUserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (state.url.includes('/dashboard/trend') || state.url.includes('/trend') || (route.data && route.data['isPublic'])) {
            return true;
        }
        return this.me.isAuth(state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (state.url.includes('/dashboard/trend') || state.url.includes('/trend') || (childRoute.data && childRoute.data['isPublic'])) {
            return true;
        }
        return this.me.isAuth(state);
    }
}
